import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, MapPinIcon } from 'lucide-react';
import { priceLists } from '../../data/priceLists';
import { destinationPath } from '../../utils/paths';
import type { Destination, Season } from '../../types/content';
interface CampusCompareProps {
  campuses: {
    destination: Destination;
    highlight: string;
  }[];
  season?: Season;
  /** Weekly tuition (English courses). Otherwise prices are quoted per programme. */
  weeklyPricing?: boolean;
  priceListOverride?: string;
}

// Side-by-side campus cards: photo, what's special there, a price and links onward.
export function CampusCompare({
  campuses,
  season = 'year-round',
  weeklyPricing = true,
  priceListOverride
}: CampusCompareProps) {
  const columns = campuses.length > 2 ? 'md:grid-cols-2 lg:grid-cols-3' : 'md:grid-cols-2';
  return <ul className={`grid gap-4 ${columns}`} data-id="element-222" data-mp="f8yyjzyp4yf7">
      {campuses.map(({
      destination,
      highlight
    }) => {
      const listSlug = priceListOverride ?? destination.priceList;
      const fromPrice = weeklyPricing ? priceLists.find(list => list.slug === listSlug)?.fromPrice : undefined;
      return <li key={destination.slug} className="flex flex-col overflow-hidden rounded-[28px] bg-white" data-id="element-223" data-mp="2grc3kj21h1m2">
            <div className="relative aspect-[16/9] overflow-hidden" data-id="element-224" data-mp="2lqonow1izuky">
              <img src={destination.image} alt={`City view in ${destination.name}`} className="h-full w-full object-cover" data-id="element-225" data-mp="2qkstvd2yvykz" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 type-small font-bold text-ink" data-id="element-226" data-mp="2vknmbl2e4w85">
                <MapPinIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-227" data-mp="34k2aueyzywq0" />
                {destination.country}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-6 md:p-8" data-id="element-228" data-mp="1a4zqevot24ty">
              <h3 className="type-h2 text-ink" data-id="element-229" data-mp="1a6j7goiacjws">{destination.name}</h3>
              <p className="mb-6 mt-3 type-card-desc text-body" data-id="element-230" data-mp="1f39obe1wzjj9">{highlight}</p>
              <div className="mt-auto flex flex-wrap items-end justify-between gap-4 border-t border-line pt-5" data-id="element-231" data-mp="2iep1apd5srub">
                <div data-id="element-232" data-mp="2dgnlqeexzanl">
                  <p className="type-small text-muted" data-id="element-233" data-mp="2dh71ppl17oyz">{weeklyPricing ? 'Tuition from' : 'Programme price'}</p>
                  <p className="type-card-title text-ink" data-id="element-234" data-mp="2rh81f1pk8qcv">
                    {fromPrice ?? (weeklyPricing ? 'Ask us' : '000')}{' '}
                    {fromPrice ? <span className="type-small font-normal text-muted" data-id="element-235" data-mp="31dkxu7chpibb">per week</span> : null}
                  </p>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-236" data-mp="2wdyklxwnw22i">
                  {listSlug ? <Link to={`/price-list/${listSlug}`} className="inline-flex h-11 items-center rounded-[15px] border-2 border-brand px-4 type-button font-bold text-ink transition-colors duration-150 hover:bg-cream" data-id="element-237" data-mp="3a53c2cpvlo1r">
                      Price list
                    </Link> : null}
                  <Link to={destinationPath(destination, season)} className="inline-flex h-11 items-center gap-1.5 whitespace-nowrap rounded-[15px] bg-brand px-4 type-button font-bold text-white transition-colors duration-150 hover:bg-brand-hover" data-id="element-238" data-mp="2lwrrl2iss42">
                    Explore {destination.name}
                    <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="3tq3k8lyos5os" />
                  </Link>
                </div>
              </div>
            </div>
          </li>;
    })}
    </ul>;
}